module.exports = __webpack_public_path__ + "static/media/android_store.5f8ffeb4.svg";